import script from "./AlbumCollaborators.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlbumCollaborators.vue?vue&type=script&setup=true&lang=ts"

import "./AlbumCollaborators.vue?vue&type=style&index=0&id=6d7384a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7384a8"]])

export default __exports__